import React from 'react';
import { func, arrayOf, string, shape } from 'prop-types';

import { Wrapper, BlockRadio, Title, Description } from './styles';

function BlockRadioButtons({
  options,
  title,
  description,
  name,
  onChange,
  value,
  ...rest
}) {
  function handleClick(id) {
    const eventObj = {
      target: {
        name,
        value: id,
      },
    };
    onChange(eventObj);
  }
  return (
    <React.Fragment>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Wrapper>
        {options.map(option => (
          <BlockRadio
            key={option.id}
            onClick={() => handleClick(option.id)}
            value={option.label}
            selected={option.id === value}
            {...rest}>
            <span>{option.label}</span>
          </BlockRadio>
        ))}
      </Wrapper>
    </React.Fragment>
  );
}

BlockRadioButtons.propTypes = {
  options: arrayOf(
    shape({
      id: string.isRequired,
      label: string.isRequired,
    })
  ).isRequired,
  value: string,
  name: string.isRequired,
  onChange: func.isRequired,
  title: string.isRequired,
  description: string.isRequired,
};

BlockRadioButtons.defaultProps = {
  value: '',
};

export default BlockRadioButtons;



// WEBPACK FOOTER //
// ./src/components/BlockRadioButtons/BlockRadioButtons.js